import { FC } from 'react';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControlLabel,
	FormGroup,
	Switch,
} from '@mui/material';
import {
	DEFAULT_WIDGETS_VISIBILITY,
	EOrderDetailWidget,
	ORDER_DETAIL_WIDGETS,
	TOrderDetailWidgetsVisibility,
} from './constants';

type TWidgetsVisibilityDialogProps = {
	open: boolean;
	onClose: () => void;
	visibility: TOrderDetailWidgetsVisibility;
	onChange: (visibility: TOrderDetailWidgetsVisibility) => void;
};

export const WidgetsVisibilityDialog: FC<TWidgetsVisibilityDialogProps> = ({
	open,
	onClose,
	visibility,
	onChange,
}) => {
	const handleToggle = (key: EOrderDetailWidget) => {
		onChange({ ...visibility, [key]: !visibility[key] });
	};

	return (
		<Dialog
			open={open}
			onClose={onClose}
			sx={{
				'& .MuiDialog-paper': {
					width: '400px',
					maxWidth: '400px',
					borderRadius: '12px',
				},
			}}
		>
			<DialogTitle color="primary">Widgets visibility</DialogTitle>
			<DialogContent>
				<FormGroup>
					{ORDER_DETAIL_WIDGETS.map(({ key, label }) => (
						<FormControlLabel
							key={key}
							control={<Switch checked={visibility[key]} onChange={() => handleToggle(key)} />}
							label={label}
						/>
					))}
				</FormGroup>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => onChange(DEFAULT_WIDGETS_VISIBILITY)}>Show all</Button>
				<Button onClick={onClose} autoFocus>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};
